<script>
  import Button from '../lib/Button.svelte';
  import { InputTypes } from '../lib/Input/enums';
  import Input from '../lib/Input.svelte';
  import covalent from '../common/covalent';
  import { getLanguageInfo, SupportedLanguages } from "../common/localization";
  import { Blockchains } from '../common/constants';
  import Icon from '../lib/Icon/Icon.svelte';
  import { Icons } from '../lib/Icon/Icons';
  import BlockchainSelect from '../lib/BlockchainSelect/BlockchainSelect.svelte';
  import { Rounding } from '../lib/enums';

  export let language = SupportedLanguages.English;
  export let initialNetwork = "btc-mainnet";
  const languageInfo = getLanguageInfo(language);

  const emptyResultState = {
    loading: false,
    value: null,
    last_transfer: null,
    balance: null,
    ticker_symbol: null,
    error: null,
    error_code: null,
    selectedBlockchain: null
  }
  
  let resultState = { ...emptyResultState }
  
  const form = {
    address: '',
    blockchain: initialNetwork
  }

  async function getBalance() {
    if (!form.address)
      return;

    setResult({ ...emptyResultState, loading: true });

    const r = await covalent.getAddressBalance(form.blockchain, form.address, covalent.getQuoteCurrencyForLanguage(language));

    setResult({
      loading: false,
      balance: r.balance * 10 ** -r.decimals,
      value: r.value,
      last_transfer: r.last_transfer
        ? new Date(r.last_transfer).toLocaleString(languageInfo.locale, { year: "numeric", month: "short", day: "numeric", hour: "2-digit", minute: "2-digit" })
        : null,
      ticker_symbol: r.ticker_symbol,
      error: r.error_code == 400
        ? "Invalid wallet address. Doublecheck the address and the selected blockchain, and try again."
        : r.error,
      error_code: r.error_code,
      selectedBlockchain: Blockchains.find(b => b.value === form.blockchain)
    });
  }

  const setResult = newResult => resultState = { ...resultState, ...newResult };

</script>



<div class="w-full font-sans py-6 bg-primary-100">
  
  <div class="flex flex-col md:flex-row items-center gap-y-4 md:gap-y-0 gap-x-0 md:gap-x-4">
    <div class="w-full flex items-center">
      <BlockchainSelect bind:value={form.blockchain} options={Blockchains} />
      <Input label="" bind:value={form.address} type={InputTypes.Text} classes="grow bg-white" rounding={Rounding.Right} placeholder="Enter wallet address" />
    </div>
    <div class="w-full md:w-min">
      <Button title="Show Balance" onClick={getBalance} showLoadingIndicator={resultState.loading} />
    </div>
  </div>

  {#if resultState.error}
    <div class="flex items-center gap-x-4 mt-4 px-6 py-4 bg-danger-100 rounded text-danger-300">
      <Icon iconType={Icons.Info} pathFill="#EE5D5D" classes="w-4 h-4" />
      <div class="text-base">
        {resultState.error}
      </div>
    </div>
    
  {/if}

  {#if resultState.value}
    <div class="flex items-center justify-between mt-4 px-6 py-4 bg-white rounded">
      <div class="flex items-center gap-x-4">
        <img class="h-16 w-16 rounded" src={resultState.selectedBlockchain.iconUrl} alt="" />
        <div>
          <div class="text-2xl font-medium">
            {resultState.selectedBlockchain.displayName} Wallet
          </div>
          {#if resultState.last_transfer}
            <div class="text-base text-neutral-900">
              Last transfer: {resultState.last_transfer}
            </div>
          {/if}
        </div>

      </div>
      <div>
        <div class="text-2xl font-medium">
          {resultState.value}
        </div>
        <div class="text-base text-neutral-900">
          {resultState.balance} {resultState.ticker_symbol}
        </div>
      </div>
    </div>
  {/if}
</div>